import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../utils/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [languageCode, setLanguageCode] = useState(() => {
    return localStorage.getItem('selectedLanguageCode') || 'en';
  });

  const [languageName, setLanguageName] = useState(() => {
    return localStorage.getItem('selectedLanguage') || 'English';
  });

  useEffect(() => {
    localStorage.setItem('selectedLanguageCode', languageCode);
    localStorage.setItem('selectedLanguage', languageName);
  }, [languageCode, languageName]);

  const changeLanguage = (code, name) => {
    setLanguageCode(code);
    setLanguageName(name);
  };

  const t = (key) => {
    const lang = translations[languageCode] || translations.en;
    return lang[key] || translations.en[key] || key;
  };

  const value = {
    languageCode,
    languageName,
    changeLanguage,
    t,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
